getAsset